import { render } from "./coaches-sidebar.vue?vue&type=template&id=8a8992b6"
import script from "./coaches-sidebar.vue?vue&type=script&lang=js"
export * from "./coaches-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__